import { useEffect, useState } from 'react'

// type ApiResponse = {
//   updated_at: string
//   data: {
//     [key: string]: {
//       name: string
//       symbol: string
//       price: string
//       price_BNB: string
//     }
//   }
// }

// type ApiResponse = {
//   THB_KUB: {
//     [key: string]: {
//       id: string
//       last: string
//       lowestAsk: string
//       highestBid: string
//       percentChange: string
//       baseVolume: string
//       quoteVolume: string
//       isFrozen: string
//       high24hr: string
//       low24hr: string
//       change: string
//       prevClose: string
//       prevOpen: string
//     }
//   }
// }
type ApiResponse = {
  result:string

}
// {"THB_KUB":{"id":92,"last":26.1,"lowestAsk":26.1,"highestBid":26.02,"percentChange":2.68,"baseVolume":7296466.70754104,
// "quoteVolume":189999877.18,"isFrozen":0,"high24hr":27.5,"low24hr":24.02,"change":0.68,"prevClose":26.1,"prevOpen":25.42}}
// const api = 'https://api.pancakeswap.info/api/tokens'
const api = 'https://008vruj3t7.execute-api.ap-northeast-1.amazonaws.com/dev/getPrice/0x2009A60434dc8c8f772c9969d64868bDc2bF17B2';

const useGetPriceData = () => {
  const [data, setData] = useState<ApiResponse | null>(null)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(api)
        const res: ApiResponse = await response.json()

        setData(res)
      } catch (error) {
        console.error('Unable to fetch price data:', error)
      }
    }

    fetchData()
  }, [setData])

  return data
}

export default useGetPriceData
